import { UserCollectionsState, UserDetailsState } from '.'
import { combineReducers } from 'redux'
import { userDetailsReducer, initialUserDetailsState } from './userDetails/userDetailsReducer'
import { userCollectionsReducer, initialUserCollectionsState } from './userCollections/userCollectionsReducer'
import { SavedItemsState, savedItemsReducer, initialSavedItemsState } from './savedItems/savedItemsReducer'
import { initialReadConfirmState, readConfirmReducer, ReadConfirmState } from './readConfirm'

export interface UserDataState {
    userDetails: UserDetailsState,
    userCollections: UserCollectionsState
    savedItems: SavedItemsState
    readConfirm: ReadConfirmState
}

export const userDataReducers = combineReducers<UserDataState>({
    userDetails: userDetailsReducer,
    userCollections: userCollectionsReducer,
    savedItems: savedItemsReducer,
    readConfirm: readConfirmReducer,
})

export const initialUserDataState: UserDataState = {
    userCollections: initialUserCollectionsState,
    userDetails: initialUserDetailsState,
    savedItems: initialSavedItemsState,
    readConfirm: initialReadConfirmState,
}